import React, { useState, useRef } from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs";
import ReCAPTCHA from "react-google-recaptcha";
import useSEO from "../../../hooks/useSEO.js";
import seoConfig from "../../../hooks/seoConfig.js";

export default function NewReviews() {
  useSEO(seoConfig.newReviews);

  const [formData, setFormData] = useState({
    fio: "",
    email: "",
    review: "",
  });

  const [isAgree, setIsAgree] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupStatus, setPopupStatus] = useState("idle");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const recaptchaRef = useRef(null);

  const API_URL =
    process.env.NODE_ENV === "production"
      ? "https://api.urniidvi.ru"
      : "http://localhost:5000";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isFormValid = () => {
    return (
      formData.fio.trim() &&
      isValidEmail(formData.email) &&
      formData.review.trim() &&
      captchaValue &&
      isAgree
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!isFormValid()) {
      return setMessage("Пожалуйста, заполните все поля корректно.");
    }

    setIsSubmitting(true);
    setShowPopup(true);
    setPopupStatus("sending");

    try {
      const res = await fetch(`${API_URL}/api/send-review`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          to_email: "urniidvi-online@mail.ru",
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Ошибка отправки");

      setFormData({
        fio: "",
        email: "",
        review: "",
      });

      setIsAgree(false);
      setCaptchaValue(null);
      recaptchaRef.current.reset();
      setPopupStatus("success");
      setIsSubmitting(false);
    } catch (err) {
      setPopupStatus("error");
      setMessage(err.message);
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Оставить отзыв
      </h1>

      <p className="reviews__description">
        Уважаемые пациенты! Вы можете оставить отзыв о качестве оказания
        медицинской помощи, работе специалистов и уровне обслуживания в ГБУ СО
        «УрНИИДВиИ». Все обращения проходят модерацию.
      </p>

      <form
        onSubmit={handleSubmit}
        className="record__input-box question-answer__form"
      >
        <input
          className="record__input"
          type="text"
          name="fio"
          placeholder="ФИО"
          value={formData.fio}
          onChange={handleChange}
        />

        <input
          className="record__input"
          type="email"
          name="email"
          placeholder="E-mail"
          value={formData.email}
          onChange={handleChange}
        />

        <textarea
          className="record__input reviews-form__textarea"
          name="review"
          placeholder="Ваш отзыв"
          value={formData.review}
          onChange={handleChange}
        />

        <ReCAPTCHA
          sitekey="6LdGG7srAAAAAGK6wMRUdW1xdkSsS6areWMsJhsW"
          ref={recaptchaRef}
          onChange={setCaptchaValue}
        />

        <label className="record__text question-answer-record__text">
          <input
            type="checkbox"
            checked={isAgree}
            onChange={() => setIsAgree(!isAgree)}
          />{" "}
          Я даю согласие на обработку персональных данных (
          <a
            href="/about/privacy"
            target="_blank"
            rel="noreferrer"
            className="question-answer-text"
          >
            политика
          </a>
          )
        </label>

        {message && <p className="record__message">{message}</p>}

        <button
          type="submit"
          disabled={!isFormValid() || isSubmitting}
          className="record__button question-answer-record__button"
        >
          {isSubmitting ? "Отправка..." : "Отправить отзыв"}
        </button>
      </form>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-window">
            {popupStatus === "sending" && <p>Отправка отзыва...</p>}
            {popupStatus === "success" && (
              <>
                <p>Спасибо! Ваш отзыв успешно отправлен.</p>
                <button onClick={() => setShowPopup(false)}>Закрыть</button>
              </>
            )}
            {popupStatus === "error" && (
              <>
                <p>Ошибка при отправке. Попробуйте позже.</p>
                <button onClick={() => setShowPopup(false)}>Закрыть</button>
              </>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
